export default __webpack_public_path__ + "static/media/wave-mobile.131964ba.svg";